import React from 'react';
import { ReactComponent as LogoSVG } from '../assets/boylett-logo.svg';

const Logo = () => {
  return (
    <div className="logo">
      <LogoSVG />
    </div>
  );
};

export default Logo;